/* Ancona Pass 20 — Exact Variant Continuity (ancona-variant.js)
   Keeps the PDP Save (#AnconaSaveBtn) and Compare (#AnconaCompareBtn) buttons'
   data-url + data-price attributes in sync with the shopper's CURRENTLY-SELECTED
   public variant. Because the existing Pass 12 innovation.js (Save) and Pass 13
   launch.js (Compare) read those data attributes AT CLICK TIME, the exact variant
   (canonical product URL + ?variant=<id> + its displayed price) then travels
   automatically through Save, Compare, the header hub, the shareable shortlist,
   inquiry context, and product print/share — with NO edits to those frozen files.

   Fully additive + isolated: this reads only PUBLIC storefront DOM (the product
   form's [name="id"] + the visible price). On ANY failure it does nothing, so
   Save/Compare simply fall back to product-level data (exactly today's behavior)
   — it can only improve, never break, the captured record. No storage, no network,
   no PII. Flag: this <script> tag's data-ancona-variant attribute (empty = off).
   Revert: remove the two data-ancona-variant lines in layout/theme.liquid + this file.

   Price freshness: Dawn re-renders the price ASYNCHRONOUSLY after a variant change
   (a section fetch, signalled via its pub/sub, not a DOM change event). A single
   sync right after the change would capture the NEW variant id with the OLD price.
   So the price is re-read three ways that converge on the settled value: (a) a
   scoped MutationObserver on the price node fires when Dawn rewrites it, (b) short
   deferred re-syncs cover node-replacement the observer might miss, (c) Dawn's
   pub/sub variant event is used as an extra trigger when present. */
(function () {
  'use strict';
  if (window.__anconaVariant) return;
  window.__anconaVariant = true;

  var script = document.currentScript;
  var flag = script ? script.getAttribute('data-ancona-variant') : null;
  if (flag === '') return; /* explicit empty string disables */
  if (location.pathname.indexOf('/products/') === -1) return; /* PDP only */

  function q(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }

  function productForm() {
    return q('form[action*="/cart/add"]') || q('product-form form') || q('product-info form');
  }

  /* The current public variant id (Dawn keeps the form's hidden [name="id"] in sync
     with the selected variant). Digits only — never trust arbitrary input. */
  function selectedVariantId() {
    var f = productForm();
    var idEl = (f && f.querySelector('[name="id"]')) || q('product-info [name="id"]') || q('[name="id"]');
    var v = idEl && idEl.value != null ? String(idEl.value).replace(/[^0-9]/g, '') : '';
    return v && v.length >= 6 ? v : '';
  }

  /* A real, changeable variant picker is present (multi-variant product). */
  function hasPicker() {
    return !!q('variant-selects, variant-radios, .product-form__input input[type="radio"], .product-form__input select');
  }

  function priceScope() { return q('.product__info-container') || q('product-info') || document; }

  /* The stable node whose contents Dawn rewrites on variant change. */
  function priceNode() {
    var scope = priceScope();
    return scope.querySelector('[id^="price-"]') || scope.querySelector('.price') || null;
  }

  /* The current displayed price (Dawn re-renders it on variant change). */
  function currentPrice() {
    var scope = priceScope();
    var el = scope.querySelector('.price-item--sale:not([hidden])') ||
             scope.querySelector('.price-item--regular:not([hidden])') ||
             scope.querySelector('.price-item--regular') ||
             scope.querySelector('.price .price-item') ||
             scope.querySelector('.price');
    var t = el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return t.slice(0, 24);
  }

  function sync() {
    try {
      var vid = selectedVariantId();
      var picker = hasPicker();
      var price = currentPrice();
      ['AnconaSaveBtn', 'AnconaCompareBtn'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (!btn) return;
        var handle = btn.getAttribute('data-handle');
        if (!handle) return;
        /* Preserve whatever path the frozen Liquid rendered (product.url, which
           already carries any active locale/market prefix) rather than hardcoding
           '/products/'. Strip any query/hash we appended on a prior sync first. */
        var cur = btn.getAttribute('data-url') || ('/products/' + handle);
        var base = cur.split('?')[0].split('#')[0];
        /* Append ?variant only for a genuine multi-variant selection; single-variant
           ("Default Title") products keep the plain product URL (today's behavior). */
        btn.setAttribute('data-url', (vid && picker) ? (base + '?variant=' + vid) : base);
        if (price) btn.setAttribute('data-price', price);
      });
    } catch (e) { /* never break the PDP */ }
  }

  var pending = null;
  function schedule() { if (pending) return; pending = window.setTimeout(function () { pending = null; sync(); }, 60); }

  /* After a variant change, re-read a few times so the async price re-render is
     captured even if the observer misses a full node replacement. */
  function scheduleSettled() {
    schedule();
    window.setTimeout(sync, 350);
    window.setTimeout(sync, 750);
  }

  var mo = null;
  function observePrice() {
    if (typeof MutationObserver !== 'function') return;
    var node = priceNode();
    if (!node) return;
    try {
      if (mo) mo.disconnect();
      mo = new MutationObserver(function () { schedule(); });
      /* childList/characterData only — never attributes — so writing data-* on the
         Save/Compare buttons can never re-trigger this observer (no feedback loop). */
      mo.observe(node, { childList: true, subtree: true, characterData: true });
    } catch (e) { /* observation is best-effort */ }
  }

  function boot() {
    sync();
    observePrice();
    /* Dawn updates the hidden id + price on variant change; capture broadly + safely. */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) scheduleSettled();
    }, true);
    ['variant:change', 'variantChange', 'on:variant:change'].forEach(function (ev) {
      try { document.addEventListener(ev, scheduleSettled, true); } catch (e) {}
    });
    /* Dawn's own pub/sub variant event, when its subscribe() is exposed globally. */
    try { if (typeof window.subscribe === 'function') window.subscribe('variant-change', scheduleSettled); } catch (e) {}
    window.addEventListener('popstate', scheduleSettled);
    document.addEventListener('shopify:section:load', function () { observePrice(); scheduleSettled(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
